import {
  GET_EMPLOYEELOCATION,
  GET_EMPLOYEELOCATION_SUCCESS,
  GET_EMPLOYEELOCATION_FAIL,
  DELETE_EMPLOYEELOCATION,
  DELETE_EMPLOYEELOCATION_SUCCESS,
  DELETE_EMPLOYEELOCATION_FAIL,
  UPDATE_EMPLOYEELOCATION,
  UPDATE_EMPLOYEELOCATION_SUCCESS,
  UPDATE_EMPLOYEELOCATION_FAIL,
  ADD_NEW_EMPLOYEELOCATION,
  ADD_EMPLOYEELOCATION_SUCCESS,
  ADD_EMPLOYEELOCATION_FAIL,
  EMPLOYEELOCATION_LOADING,
  EMPLOYEELOCATION_RESET
} from "./actionType";

export const resetEmployeeLocationState = (actionType) => ({
  type: EMPLOYEELOCATION_RESET,
  payload: { actionType },
});

export const getEmployeeLocationSuccess = (actionType, data) => ({
  type: GET_EMPLOYEELOCATION_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeLocationFail = (actionType, error) => ({
  type: GET_EMPLOYEELOCATION_FAIL,
  payload: { actionType, error },
});

export const getEmployeeLocation = data => ({
  type: GET_EMPLOYEELOCATION,
  payload: data,
});

export const getEmployeeLocationLoading = () => ({
  type: EMPLOYEELOCATION_LOADING
});

export const deleteEmployeeLocation = data => ({
  type: DELETE_EMPLOYEELOCATION,
  payload: data,
});

export const deleteEmployeeLocationSuccess = data => ({
  type: DELETE_EMPLOYEELOCATION_SUCCESS,
  payload: data,
});

export const deleteEmployeeLocationFail = error => ({
  type: DELETE_EMPLOYEELOCATION_FAIL,
  payload: error,
});

export const updateEmployeeLocation = data => ({
  type: UPDATE_EMPLOYEELOCATION,
  payload: data,
});

export const updateEmployeeLocationFail = error => ({
  type: UPDATE_EMPLOYEELOCATION_FAIL,
  payload: error,
});

export const updateEmployeeLocationSuccess = data => ({
  type: UPDATE_EMPLOYEELOCATION_SUCCESS,
  payload: data,
});

export const addNewEmployeeLocation = data => ({
  type: ADD_NEW_EMPLOYEELOCATION,
  payload: data,
});

export const addEmployeeLocationSuccess = data => ({
  type: ADD_EMPLOYEELOCATION_SUCCESS,
  payload: data,
});

export const addEmployeeLocationFail = error => ({
  type: ADD_EMPLOYEELOCATION_FAIL,
  payload: error,
});